<template>
  <div class="socials">
    <NuxtLink
      v-for="social in socials"
      :key="social.id"
      :to="social.slug"
      @click="handleClick(social.id)"
    >
      <NuxtImg
        :src="`/icons/${social.icon}`"
        :alt="social.label"
        format="webp"
        width="22"
      />
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
  const socials: any[] = [
    { id: 'twitter', label: 'Twitter', slug: 'https://twitter.com/airBaltic', icon: 'twitter.svg' },
    { id: 'facebook', label: 'Facebook', slug: 'https://www.facebook.com/airBaltic', icon: 'facebook.svg' },
    { id: 'youtube', label: 'YouTube', slug: 'https://www.youtube.com/@airbalticBT', icon: 'youtube.svg' },
    { id: 'instagram', label: 'Instagram', slug: 'https://www.instagram.com/airbaltic', icon: 'instagram.svg' },
    { id: 'tiktok', label: 'TikTok', slug: 'https://www.tiktok.com/@airbaltic', icon: 'tiktok.svg' },
    { id: 'linkedin', label: 'LinkedIn', slug: 'https://www.linkedin.com/company/airbaltic/', icon: 'linkedin.svg' }
  ]

  const handleClick = (code: string) => {
    GTM.pressSocial(code)
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .socials {
    align-items: center;
    display: flex;
    justify-content: center;

    a {
      padding: rem(2) rem(4);

      &:not(:last-child) {
        margin-right: rem(24);

        @include tablet-up {
          margin-right: rem(34);
        }
      }

      img {
        width: 22px;
        max-width: 22px;
      }
    }
  }
</style>
